const RESET_MESSAGE = 'RESET_MESSAGE';
export function resetMessage() {
  return {
    type: RESET_MESSAGE,
  };
}

const SET_MESSAGE = 'SET_MESSAGE';
export function setMessage(title, message, onConfirm, onClose, titleColor, onCancel) {
  return {
    type: SET_MESSAGE,
    title,
    message,
    onConfirm,
    onCancel,
    titleColor,
    onClose,
  };
}

const initialState = {
  message: '',
  errorMessage: '',
  title: '',
  onConfirm: undefined,
  onCancel: undefined,
  titleColor: undefined,
  onClose: undefined,
  status: '',
  errorHttpStatus: null,
};
export default function reducer(state = initialState, action) {
  const { error, type, payload } = action;
  const axiosStatus = payload && payload.response && payload.response.status;
  const axiosError = payload && payload.response && payload.response.data;
  if (axiosError instanceof Blob) return state;
  if (type === SET_MESSAGE) {
    return Object.assign({}, state, {
      message: action.message,
      title: action.title,
      onConfirm: action.onConfirm,
      onCancel: action.onCancel,
      titleColor: action.titleColor,
      onClose: action.onClose,
    });
  } else if (type === RESET_MESSAGE) {
    return initialState;
  } else if (error && (error.httpStatus > 400 || axiosStatus > 400)) {
    return Object.assign({}, state, {
      message: error.message || (axiosError && axiosError.error && axiosError.error.title),
      onConfirm: undefined,
      onCancel: undefined,
      onClose: undefined,
      status: error.status || axiosStatus,
      errorHttpStatus: error.httpStatus || axiosStatus,
    });
  }
  return state;
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/reducers/messageReducer.js
 **/